import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M3 6h18" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 10,
			y1: 11,
			x2: 10,
			y2: 17
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 14,
			y1: 11,
			x2: 14,
			y2: 17
		})
	]
});
export default SvgTrash;
